// extracted by mini-css-extract-plugin
module.exports = {"container":"CartTicketItemStatus_container__ELvmn","ready":"CartTicketItemStatus_ready__nyqBX","pickedUp":"CartTicketItemStatus_pickedUp__n4QOf"};